import React from "react";
import ActiveFlagForm from "./ActiveFlagForm";

import { useApi } from "../../../../../api";
import { setFieldErrorsFromResponse } from "../../../../../utils/formErrors";
import useI18nSnackbar from "../../../../../hooks/useI18nSnackbar";

const ActiveFlagContainer = ({ device, onClose }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    api
      .put(`/v2/devices/${device.id}/active-flag`, values)
      .then(() => {
        enqueueSnackbar(
          "devices.settings.metadata.responses.activeFlagUpdated",
          {
            variant: "success"
          }
        );

        onClose(true);
      })
      .catch(e => {
        if (!e.response) {
          return;
        }

        setSubmitting(false);
        setFieldErrorsFromResponse(e.response, setFieldError);
      });
  };

  const values = {
    active: device.active
  };

  return (
    <ActiveFlagForm values={values} onClose={onClose} onSubmit={handleSubmit} />
  );
};

export default ActiveFlagContainer;
